// extracted by mini-css-extract-plugin
export var Bar = "Footer-module--Bar--EwO-K";
export var Career = "Footer-module--Career--kGlgA";
export var ColumnDisplay = "Footer-module--ColumnDisplay--E201L";
export var Community = "Footer-module--Community--1syQC";
export var English = "Footer-module--English--wDlfb";
export var Footer = "Footer-module--Footer--bypkC";
export var FooterLinksWrapper = "Footer-module--FooterLinksWrapper--4SQbZ";
export var Hr = "Footer-module--Hr--bR5Wp";
export var ReservedFooter = "Footer-module--ReservedFooter--0NW1j";
export var ReservedFooterLinksLg = "Footer-module--ReservedFooterLinksLg--v347X";
export var ReservedFooterLinksSm = "Footer-module--ReservedFooterLinksSm--YdM-l";
export var ReservedFooterText = "Footer-module--ReservedFooterText--7FqHL";
export var RowDisplay = "Footer-module--RowDisplay--eldry";
export var RowDisplaySm = "Footer-module--RowDisplaySm--FEalk";
export var SocialBtns = "Footer-module--SocialBtns--St-nn";
export var Subscribe = "Footer-module--Subscribe--z4ufr";
export var TooltipText = "Footer-module--TooltipText--e2H9Z";